import { PageHero } from "@/components/Sections";
import { LeadForm } from "@/components/LeadForm";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { Phone, Mail, Globe, MessageSquare, MapPin, Clock, Navigation } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1758411898312-8592bb81e30d?w=1600";

const HOURS = [
  { d: "Lundi", h: "10h00 – 13h00 · 14h00 – 18h00" },
  { d: "Mardi", h: "10h00 – 13h00 · 14h00 – 18h00" },
  { d: "Mercredi", h: "10h00 – 13h00 · 14h00 – 18h00" },
  { d: "Jeudi", h: "10h00 – 13h00 · 14h00 – 18h00" },
  { d: "Vendredi", h: "10h00 – 13h00 · 14h00 – 18h00" },
  { d: "Samedi", h: "10h00 – 13h00 · 14h00 – 18h00" },
  { d: "Dimanche", h: "Fermé" },
];
const DIRECTIONS_URL = "https://www.google.com/maps/dir/?api=1&destination=3+rue+de+Kerandr%C3%A9+56700+Hennebont";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        overline="Contactez AS AUTO"
        title="Vous avez un projet automobile ?"
        subtitle="Que vous souhaitiez acheter, vendre, importer, rechercher ou réparer un véhicule, notre équipe est à votre écoute."
        image={HERO}
      />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20 grid gap-12 lg:grid-cols-5">
        <Reveal className="lg:col-span-2">
          <div>
            <h2 className="font-display text-3xl font-bold text-white">AS AUTO</h2>
            <p className="text-neutral-400 mt-3">Un projet ? Une question ? Une demande de devis ? Notre équipe est à votre disposition.</p>
            <div className="mt-8 space-y-4">
              <a href="tel:0767876026" data-testid="contact-phone" className="flex items-center gap-4 bg-[#121212] border border-white/10 rounded-sm p-5 hover:border-[#C5A059] transition-colors">
                <Phone className="h-6 w-6 text-[#C5A059]" />
                <div><p className="text-xs text-neutral-500">Téléphone</p><p className="text-white font-semibold">07 67 87 60 26</p></div>
              </a>
              <a href="mailto:as.56.auto@gmail.com" data-testid="contact-email" className="flex items-center gap-4 bg-[#121212] border border-white/10 rounded-sm p-5 hover:border-[#C5A059] transition-colors">
                <Mail className="h-6 w-6 text-[#C5A059]" />
                <div><p className="text-xs text-neutral-500">E-mail</p><p className="text-white font-semibold">as.56.auto@gmail.com</p></div>
              </a>
              <a href="https://www.google.com/maps/search/?api=1&query=3+rue+de+Kerandr%C3%A9+56700+Hennebont" target="_blank" rel="noreferrer" data-testid="contact-address" className="flex items-center gap-4 bg-[#121212] border border-white/10 rounded-sm p-5 hover:border-[#C5A059] transition-colors">
                <MapPin className="h-6 w-6 text-[#C5A059]" />
                <div><p className="text-xs text-neutral-500">Adresse</p><p className="text-white font-semibold">3 rue de Kerandré, 56700 Hennebont</p></div>
              </a>
              <div className="flex items-center gap-4 bg-[#121212] border border-white/10 rounded-sm p-5">
                <Globe className="h-6 w-6 text-[#C5A059]" />
                <div><p className="text-xs text-neutral-500">Site internet</p><p className="text-white font-semibold">as-auto.fr</p></div>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              <a href="tel:0767876026"><Button className="bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm"><Phone className="h-4 w-4 mr-2" /> Appeler</Button></a>
              <a href="mailto:as.56.auto@gmail.com"><Button variant="outline" className="border-white/20 text-white hover:bg-white/5 rounded-sm"><Mail className="h-4 w-4 mr-2" /> Envoyer un e-mail</Button></a>
              <a href={DIRECTIONS_URL} target="_blank" rel="noreferrer"><Button data-testid="directions-btn" variant="outline" className="border-white/20 text-white hover:bg-white/5 rounded-sm"><Navigation className="h-4 w-4 mr-2" /> M'y rendre</Button></a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-3">
          <div className="bg-[#0f0f0f] border border-white/10 rounded-sm p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-6">
              <MessageSquare className="h-6 w-6 text-[#C5A059]" />
              <h2 className="font-display text-2xl font-bold text-white">Envoyez-nous un message</h2>
            </div>
            <LeadForm
              type="contact"
              submitLabel="Envoyer le message"
              fields={[
                { name: "subject", label: "Sujet", type: "select", full: true, options: ["Achat", "Vente / Reprise", "Recherche personnalisée", "Importation", "Atelier / Réparation", "Autre"] },
                { name: "message", label: "Votre message", type: "textarea", full: true },
              ]}
            />
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-24">
        <Reveal>
          <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
            <div className="flex items-center gap-3">
              <MapPin className="h-6 w-6 text-[#C5A059]" />
              <h2 className="font-display text-2xl font-bold text-white">Nous trouver</h2>
            </div>
            <a href={DIRECTIONS_URL} target="_blank" rel="noreferrer">
              <Button data-testid="directions-btn-map" className="bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm"><Navigation className="h-4 w-4 mr-2" /> M'y rendre</Button>
            </a>
          </div>
          <div className="grid gap-6 lg:grid-cols-3">
            <div data-testid="opening-hours" className="bg-[#121212] border border-white/10 rounded-sm p-6">
              <div className="flex items-center gap-2 mb-4">
                <Clock className="h-5 w-5 text-[#C5A059]" />
                <h3 className="font-display text-lg font-semibold text-white">Horaires d'ouverture</h3>
              </div>
              <ul className="space-y-2">
                {HOURS.map((row) => (
                  <li key={row.d} className="flex items-start justify-between gap-3 text-sm border-b border-white/5 pb-2 last:border-0">
                    <span className="text-neutral-300">{row.d}</span>
                    <span className={`text-right ${row.h === "Fermé" ? "text-neutral-600" : "text-white"}`}>{row.h}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:col-span-2 rounded-sm overflow-hidden border border-white/10 min-h-[420px]">
              <iframe
                title="AS AUTO — 3 rue de Kerandré, 56700 Hennebont"
                data-testid="contact-map"
                src="https://maps.google.com/maps?q=3%20rue%20de%20Kerandr%C3%A9%2056700%20Hennebont&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: "420px", filter: "grayscale(0.2) contrast(1.05)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
